import { pick } from "lodash-es";
import { SharedApiV2 } from "@capstone/mock-api";
import { SiteUpdate } from "./site-update.model";
import { Site } from "./site.model";

export class SiteGeneralSettingsUpdate {
  public constructor(private readonly update: SiteUpdate) {}

  public get base(): Site | null {
    return this.update.base;
  }

  public serialize(): SharedApiV2.PatchGeneralSiteDto {
    return pick(this.update.serialize(), [
      "address",
      "appointmentDateLimit",
      "appointmentTimeStampsAndDoorDetailsAreViewable",
      "businessDayOffset",
      "captureLateDueDate",
      "captureTrailerNumber",
      "captureTrailerTempActual",
      "captureTrailerTempSet",
      "carrierAppointmentFlow",
      "displayName",
      "dockCapacityType",
      "dropTrailerCDLNumber",
      "dropTrailerDriverName",
      "dropTrailerDriverNumber",
      "earlyArrivalInMinutes",
      "earlyScheduleThreshold",
      "enableYardManagementSystem",
      "lateArrivalInMinutes",
      "lateDueDateMessage",
      "lateScheduleThreshold",
      "limitPastDueDateNotifications",
      "liveTrailerCDLNumber",
      "liveTrailerDriverName",
      "liveTrailerDriverNumber",
      "manageTypeCFeature",
      "noDropAllowedOnManagedTypeT",
      "noShowNoCallInMinutes",
      "promptSameDayApptConfirmation",
      "rescheduleMinimumAdvancedHours",
      "status",
      "supportEmail",
      "timeZone",
      "unitType",
      "unrestrictedAppointmentActions",
      "useAisleNumbers",
    ]);
  }
}
